/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Image, Row, Col, Tooltip, Divider, InputNumber, Alert } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { customerInfoData } from '../../redux/reducers/customerInfo_reducer'
import { PutShoppingCartReq } from '../../models/shoppingCartItem'
import { productsData } from '../../redux/reducers/product_reducer'
import { useSelector } from 'react-redux'
import AttributesProduct from './productAttr'
import { findLastIndex, forEach, keys, reduce, values } from 'lodash'
import api from '../../config/api'
import { BundledProductResTypes } from '../../models/productQuery'
import { FormattedMessage } from 'react-intl'

const Box = styled.div`
  .ant-input-number-lg input {
    height: 45px;
  }
`
const CardStyle = styled.div<{ choose: number }>`
  position: relative;
  transition: all 0.5s ease;
  ::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    border: ${(props) => (props.choose ? '18px solid orange' : 'none')};
    border-top-color: transparent;
    border-left-color: transparent;
    z-index: 1000;
  }
  ::after {
    content: '';
    width: 7px;
    height: 14px;
    position: absolute;
    right: 6px;
    bottom: 0.5rem;
    border: ${(props) => (props.choose ? '2px solid white' : 'none')};
    border-top-color: transparent;
    border-left-color: transparent;
    transform: rotate(45deg);
    z-index: 1000;
  }
  border-color: ${(props) => (props.choose ? 'orange' : 'lightgrey')};
  :hover {
    cursor: pointer;
  }
`
const Img = styled.img`
  object-fit: cover;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const ImageStyle = styled(Image) <{ choose: any }>`
  border: ${(props) => (props.choose ? '1px solid orange' : '1px solid lightgrey')};
  object-fit: cover;
`

interface Props {
  itemChoose: (value: PutShoppingCartReq) => void
}

const BundledProduct = (props: Props) => {
  const [totalPrice, setTotalPrice] = useState(0)
  const [itemChange, setItemChange] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [isSelect, setIsSelect] = useState([])
  const [saleNum, setSaleNum] = useState([])
  const [chooseProductName, setChooseProductName] = useState([])
  const [tirePrice, setTirePrice] = useState({})
  const [attrProductSelected, setAttrProductSelected] = useState({})
  const [defaultProductType, setDefaultProductType] = useState([])
  const [hasItemInItemList, setHasItemInItemList] = useState(true)
  const [num, setNum] = useState(1)
  const { itemChoose } = props
  const storeState = useSelector(customerInfoData)
  const {
    bundledProductData: data,
    bundledProductSummary: productSummary,
    bundledProductId: bundledId,
    bundledProductPrice: bundledPrice
  } = useSelector(productsData)
  // var attrProductSelected = {}

  const onFinish = (value) => {
    value = value.flat()
    const products = data
      .map((element) => {
        return value
          .map((v) =>
            element.selections.find((item) => item.skuId === v[element.id])
              ? { ...element.selections.find((item) => item.skuId === v[element.id]), optionId: element.id }
              : null
          )
          .filter((ele) => !!ele)
      })
      .flat()

    const productExtra = products.map((item) => {
      return {
        optionId: item.optionId,
        selectionId: item.selectionId,
        productId: item.productId,
        skuId: item.skuId
      }
    })
    const res = {
      customerId: storeState.customerId,
      storeId: Number(localStorage.getItem('storeId')),
      productId: bundledId,
      productExtra,
      quantity: num
    }
    itemChoose(res)
  }

  const sortArrData = (arrData, element) => {
    return arrData
      .map((ele) => {
        for (const [key] of Object.entries(ele)) {
          if (+key !== element.id) {
            return ele
          }
        }
        return null
      })
      .filter((item) => !!item)
  }

  const getFinalPriceOfSelections = (arrData: BundledProductResTypes[]) => {
    return arrData
      .map((item) => {
        if (item.selections.find((item) => !!item.isDefault)?.product?.finalPrice || item.selections[0]?.product?.finalPrice) {
          return {
            [item.id]: item.selections.find((item) => !!item.isDefault)?.product?.finalPrice || item.selections[0]?.product?.finalPrice
          }
        } else {
          return null
        }
      })
      .filter((p) => !!p)
  }

  useEffect(() => {
    if (!data) {
      return
    }

    setNum(productSummary.items[0].unitMin)
    const arr = getFinalPriceOfSelections(data)

    const selectArr = data.map((item) => {
      return {
        [item.id]: item.selections.find((item) => !!item.isDefault)?.skuId || item.selections[0]?.skuId
      }
    })
    const defaultProductsType = data.map((item) => {
      return item.selections.find((item) => !!item.isDefault)?.product?.typeId || item.selections[0]?.product?.typeId
    })
    setDefaultProductType(defaultProductsType)
    // setSelectedItems(arr)
    setIsSelect(selectArr)
  }, [data])

  // useEffect(() => {
  //   if (!data) {
  //     return
  //   }
    // if (bundledPrice === 0) {
    //   if (itemChange) {
    //     setItemChange(false)
    //     let price = 0
    //     const arr = []
    //     for (let i = 0; i < data.length; i++) {
    //       arr.push(selectedItems[i])
    //     }
    //     arr.forEach((element) => {
    //       for (const key in element) {
    //         price = price + element[key]
    //       }
    //     })
    //   } else {
    //     let price = 0
    //     const arr = getFinalPriceOfSelections(data)
    //     const productName = data.map((item) => {
    //       return {
    //         [item.id]: item.selections.find((item) => !!item.isDefault)?.product?.shippingName || item.selections[0]?.product?.shippingName
    //       }
    //     })
    //     const productSalesNum = data.map((item) => {
    //       return {
    //         [item.id]: item.selections.find((item) => !!item.isDefault)?.selectionQty || item.selections[0]?.selectionQty
    //       }
    //     })
    //     arr.forEach((element) => {
    //       for (const key in element) {
    //         price = price + element[key]
    //       }
    //     })
    //     setChooseProductName(productName)
    //     setSaleNum([...productSalesNum])
    //   }
    // }
  // }, [selectedItems, data])

  useEffect(() => {
    if (!data) {
      return
    }
    if (
      selectedItems.length === 0 ||
      (values(attrProductSelected).length !== 1 && !!defaultProductType.find((item) => item === 'variant'))
    ) {
      return
    }

    if (!productSummary.finalPrice && keys(tirePrice).length > 1 && defaultProductType.find((item) => item === 'variant')) {
      setTotalPrice(0)
      return
    }

    if (JSON.stringify(selectedItems) !== JSON.stringify(getFinalPriceOfSelections(data)) && keys(tirePrice).length === 1) {
      return
    }
    const defaultProducts = data
      .map((item) => {
        return (
          item.selections.find((item) => !!item.product.items.find((a) => a.isDefault))?.product.items || item.selections[0]?.product.items
        )
      })
      .filter((p) => !!p)
      .flat()
      .map((item) => {
        if (item.isDefault) {
          return item
        }
        return null
      })
      .filter((a) => !!a)
    let defaultA = {}

    forEach(data, (value) => {
      forEach(value.selections, (selection) => {
        defaultA = {
          ...defaultA,

          [selection.productId]:
            value.selections.find((item) => !!item.isDefault)?.product.items.find((a) => a.isDefault) ||
            value.selections.find((item) => item.productId === selection.productId).product.items.find((a) => a.isDefault)
        }
      })
    })
    if (defaultProductType.find((item) => item === 'variant')) {
      setAttrProductSelected(defaultA)
    }

    if (!defaultProducts) {
      return
    }
    let total = 0
    forEach(defaultProducts, (product) => {
      if (product.priceTiers.length === 0) {
        total = total + product.finalPrice
      } else if (num >= product.priceTiers[findLastIndex(product.priceTiers, (item) => item.unitMin <= num)]?.unitMin) {
        total = total + product.priceTiers[findLastIndex(product.priceTiers, (item) => item.unitMin <= num)].price
      } else {
        total = total + product.finalPrice
      }
    })
    if (productSummary.finalPrice !== 0) {
      setTotalPrice(productSummary.finalPrice)
    } else {
      setTotalPrice(total)
    }
  }, [selectedItems, num, tirePrice, attrProductSelected, defaultProductType, data])

  const sortData = (product, element) => {
    if (!product) {
      return
    }
    const productInfo = product
      .map((product) => {
        for (const [key, value] of Object.entries(product)) {
          if (+key === element.id) {
            return value
          }
        }
        return null
      })
      .filter((item) => !!item)[0]
    return productInfo
  }

  const imageUrl = (img) => {
    let url = img
    if (!!img && (img.slice(0, 7) == 'http://' || img.slice(0, 8) == 'https://'))
      url = img
    else
      url = `${api.cdn}/${img}?x-oss-process=style/640w`
    return url
  }

  return (
    <div style={{ marginTop: '25px' }}>
      <Row wrap={false}>
        <Col span={8}>
          <div style={{ position: 'relative', paddingTop: 'calc(100%)' }}>
            <Img src={`${imageUrl(productSummary.imageList[0])}`} />
          </div>
          <Row>
            {productSummary.imageList.map((item, index) => (
              <Col span={6} key={index}>
                <div style={{ position: 'relative', paddingTop: 'calc(100%)' }}>
                  <Img src={`${imageUrl(item)}`} />
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        <Col span={15} offset={1}>
          <div style={{ fontSize: '0.8rem', fontWeight: 700, marginBottom: '5px' }}>{productSummary?.shippingName}</div>

          {data.map((element, index) => {
            return (
              <div key={element.id}>
                <Row>
                  {element.title}
                </Row>
                <Row>
                  <Col span={24}>
                    <Row gutter={[16, 16]} style={{marginBottom: '10px'}}>
                      {element.selections.map((item) => {
                        return (
                          <Col span={6} key={item.id}>
                                <Row justify='space-between' align='middle'>
                                  <Col style={{ width: '100%' }}>
                                    <Tooltip title={item.productName + (item.skuName ? ' - ' + item.skuName : '') + " * " + item.selectionQty}>
                                      <CardStyle
                                        choose={ isSelect.flat().find((x) => x[element.id] === item.skuId) ? 1 : 0}
                                        onClick={() => {
                                          setIsSelect([
                                            ...isSelect
                                              .flat()
                                              .map((item) => {
                                                for (const key in item) {
                                                  if (+key === element.id) {
                                                    continue
                                                  }
                                                  return { [key]: item[key] }
                                                }
                                                return null
                                              })
                                              .filter((item) => !!item),
                                            { [element.id]: item.skuId }
                                          ])
                                          setItemChange(true)
                                        }}
                                      >
                                        <ImageStyle
                                          choose={ isSelect.flat().find((x) => x[element.id] === item.skuId) ? 1 : 0}
                                          width='100%'
                                          height='5rem'
                                          preview={false}
                                          placeholder={true}
                                          alt='example'
                                          src={`${imageUrl(item.productImage)}`}
                                          fallback='data:image/png;base64,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'
                                        />
                                      </CardStyle>
                                    </Tooltip>
                                  </Col>
                                </Row>
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              </div>
            )
          })}
          <Row align='middle' style={{ marginTop: '15px' }}>
            <Col span={5}>
              <FormattedMessage id='amount' />
            </Col>
            <Col span={10}>
              <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
                <InputNumber
                  size='large'
                  formatter={(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => +value.replace(/\$\s?|(,*)/g, '')}
                  min={productSummary.items[0].unitMin}
                  max={productSummary.items[0].unitMax === 0 ? 9999999999 : productSummary.items[0].unitMax}
                  value={num}
                  onChange={(value) => {
                    setNum(value)
                  }}
                />
              </Box>
            </Col>
          </Row>
          <Row style={{ marginTop: '10px' }} align='middle'>
            <Col span={5}>
              <FormattedMessage id='price' />
            </Col>
            <Col span={19} style={{ fontSize: '1rem', fontWeight: 500 }}>
              ${(productSummary.finalPrice * num).toFixed(2)}
            </Col>
          </Row>
          <Row style={{marginTop: '10px'}}>
            <Col span={5}></Col>
            <Col span={10} style={{ height: '100%' }}>
              <Button
                onClick={() => {
                  onFinish(isSelect)
                }}
                block
                style={{
                  background: hasItemInItemList ? 'orange' : '',
                  color: hasItemInItemList ? 'white' : '',
                  height: '100%',
                  backgroundColor: 'orange',
                  letterSpacing: localStorage.getItem('lang') === 'zh-CN' ? '0.5rem' : 0
                }}
              >
                <FormattedMessage id='purchase' />
              </Button>
            </Col>
            <Col offset={9}>{!hasItemInItemList && <Alert message='Sold Out' type='error' showIcon />}</Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default BundledProduct
